<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

     <el-tabs class="mt-0" v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="Contact information" name="ContactInfo">
          <br>
          <div class="row">
            <fg-input class="col-md-6" type="text"
                label="First Name"
                id="affiliate-focus"
                placeholder="First Name"
                v-model="invitation.affiliateProxy.firstName"
                @keyup.enter="inviteAffiliate()"
                required
                ref="tofocus"/>

            <fg-input class="col-md-6" type="text"
              label="Last Name"
              placeholder="Last Name"
              v-model="invitation.affiliateProxy.lastName"
              @keyup.enter="inviteAffiliate()"/>
          </div>

          <fg-input type="text"
              label="Position"
              placeholder="Position"
              v-model="invitation.position"
              @keyup.enter="inviteAffiliate()"/>

          <fg-input type="text"
              label="Work Email"
              placeholder="Work email"
              v-model="invitation.affiliateProxy.email2"
              required
              @keyup.enter="inviteAffiliate()"/>

          <fg-input type="text"
              label="Company name"
              placeholder="Company name"
              v-model="invitation.companyName"
              required
              @keyup.enter="inviteAffiliate()"/>
        </el-tab-pane>

      </el-tabs>

    

    <span slot="footer" class="dialog-footer">
      <div>
        <fg-input>
          <l-checkbox v-model="invitation.cc">
            cc me
          </l-checkbox>
        </fg-input>
      </div>
      <div class="row">
        <!-- <span v-if="modalState.mode != 'Create'" class="col-1">
          <button v-if="deletable" class="btn btn-danger" @click="deleteAffiliate()">Delete</button>
          <button v-else-if="archived" class="btn" @click="toggleArchive()">Unarchive</button>
          <button v-else class="btn" @click="toggleArchive()">Archive</button>
        </span> -->

        <span class="ml-auto col-4">
          <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
          <button class="btn btn-success" @click="inviteAffiliate()">Invite</button>
        </span>
      </div>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Affiliate-Invitation-Modal',
  data () {
    return {
      activeTab: 'ContactInfo',
      invitation: { name: 2, affiliateProxy: {}, cc: true }
    }
  },
  computed: {
    modalState () {
      return this.$store.getters.modal
    },
    title () {
      return 'Invite Affiliate'
    },
    visible () {
      return this.$store.state.modal.current == 'Invite Affiliate'
    },
    affiliate () {
      return this.invitation.affiliateProxy
    },
    archived: { get()  { return this.affiliate.archived; },
                set(archived) { this.affiliate.archived = archived }
    },
    firstName: { get() { return this.invitation.affiliateProxy.firstName; },
            set(firstName)    { this.invitation.affiliateProxy.firstName = firstName }
    },
    lastName: { get() { return this.affiliate.lastName; },
            set(lastName)    { this.affiliate.lastName = lastName }
    },
    position: { get() { return this.affiliate.position },
             set(position)   { this.affiliate.position = position }
    },
    email2: { get() { return this.affiliate.email2 },
             set(email2)   { this.affiliate.email2 = email2 }
    },
    companyName: { get() { return this.invitation.companyName },
             set(companyName)   { this.invitation.companyName = companyName }
    },
    cc: { get() { return this.invitation.cc || true },
               set(cc) { this.invitation.cc = cc }},
    deletable: { get()   { return this.affiliate.deletable },
                 set(deletable) { this.affiliate.deletable = deletable }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
      // we hide any edit input field (for manual payouts) that would still be open
      // (otherwise they'll appear in the next Payout table...)
      $('.toHideWhenClosing').each(function() {
        $(this).addClass('d-none')
      })
      // and show the normmal divs back
      $('.toShowWhenClosing').each(function() {
        $(this).removeClass('d-none')
      })
    },
    toggleArchive () {
      this.archived = !this.archived
    },
    async inviteAffiliate () {
      // var mode = this.$store.state.modal.mode
      // const res = await this.$store.dispatch(mode=='Edit'?'updateRestObject':'createRestObject', new AffiliateProxy(this.affiliate))
      const res = await this.$store.dispatch('inviteAffiliate', this.invitation)
      if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Invitation sent!'})
             this.closeModal()
      }
    },
    handleClick(tab, event) {
      //console.log(tab, event)
    }
  },
  mounted () {
    // $('#affiliate-focus').focus()
    // document.getElementById('affiliate-focus').focus()
    // $('#affiliate-focus').attr('autofocus', true)
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // doesn't work without the timeout..
        setTimeout(() => this.$refs.tofocus.$el.children[1].focus(), 500)
        this.activeTab = 'ContactInfo'
        this.invitation = { affiliateProxy: {}, cc: true }
      }
    }
  }
}
</script>

<style>

</style>